/**
 * Cycle Settings — threshold validation and formatting helpers.
 */

export function validateProjectThresholdData(data) {
  const errors = {};
  if (!data.location && !data.name) {
    errors.location = 'Location is required.';
  }
  const thresholdNum = parseThresholdValue(data.threshold);
  if (
    data.threshold === null ||
    data.threshold === undefined ||
    data.threshold === '' ||
    (typeof data.threshold === 'string' && data.threshold.trim() === '') ||
    thresholdNum === null ||
    thresholdNum === undefined ||
    isNaN(thresholdNum) ||
    typeof thresholdNum !== 'number' ||
    !isFinite(thresholdNum)
  ) {
    errors.threshold = 'Threshold is required and must be a valid number.';
  } else if (thresholdNum !== 0 && Math.abs(thresholdNum) < 1e-8) {
    errors.threshold = 'Threshold value is too or empty.';
  }
  return errors;
}

export function formatThresholdDisplay(input) {
  const number = Number(input);
  if (isNaN(number) || input === null || input === undefined || input === '') {
    return '';
  }
  return number.toLocaleString('en-US');
}

export function parseThresholdValue(value) {
  if (value === null || value === undefined || value === '') return value;
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }
  let str = String(value).replace(/,/g, '').trim();
  const zeroMinusMatch = str.match(/^0-(\d+(?:\.\d+)?)$/);
  if (zeroMinusMatch) {
    str = `-${zeroMinusMatch[1]}`;
  }
  const parsed = Number(str);
  return Number.isFinite(parsed) ? parsed : null;
}

export function formatThresholdRows(listdata = [], locationListdata = []) {
  const enriched = (listdata || []).filter((obj1) => {
    return (locationListdata || []).filter((obj2) => {
      if (obj2._id === obj1.location) {
        obj1.locationName = obj2.name;
        return obj1;
      }
      return false;
    });
  });

  return enriched.map((item, index) => ({
    __key: index,
    __formatedkey: index,
    _id: item._id,
    indexno: index + 1,
    name: item.locationName,
    locationId: item.locationId || item.location,
    location: item.location,
    threshold: formatThresholdDisplay(item.threshold),
    created_at: item.created_at,
    updated_at: item.updated_at,
    status: item.status
  }));
}

export function getEligibleLocations(locationListdata = [], listdata = [], excludedLocationId = '') {
  const configuredSet = new Set(
    (listdata || []).map((item) => item && item.location).filter(Boolean)
  );
  if (excludedLocationId) configuredSet.delete(excludedLocationId);
  return (locationListdata || []).filter((item) => !configuredSet.has(item._id));
}
